import { ProIp } from "./ApiURL";


//Post Mapping :id

export const getClassMasterAPI=ProIp+"Class/getClassMaster/";

